import uniqueIdGenerator from '@src/utils/uniqueIdGenerator'

import { ANALYTIC_COOKIES, LOCAL_STORAGE_DEVICE_ID } from './constants'
import getCookie from './getCookie'
import isBrowser from './isBrowser'
import setCookie from './setCookie'
// import { setInLocalStorageWithExpiry } from './setInLocalStorageWithExpiry'

export const getlbUserId = () => {
  if (!isBrowser()) return
  return getCookie(ANALYTIC_COOKIES.LB_USER_ID_SERVER) ?? getCookie(ANALYTIC_COOKIES.LB_USER_ID) ?? ''
}

// This deviceid is different from lbUserId.
// TnS services use this deviceid to identify the device.
// We call tns service to generate this deviceid and used for user authentication by tns services
// Send this in headers for tns services. eg x-device-id: "value"
export const getDeviceIdFromLocalStorage = () => {
  if (!isBrowser()) return
  // eslint-disable-next-line @quince/no-direct-localstorage
  return window.localStorage.getItem(LOCAL_STORAGE_DEVICE_ID) ?? ''
}
export const setDeviceIdInLocalStorage = (deviceId: string) => {
  if (!isBrowser() || !deviceId) return
  // eslint-disable-next-line @quince/no-direct-localstorage
  window.localStorage.setItem(LOCAL_STORAGE_DEVICE_ID, deviceId)
}

export function createLastBrandUserId() {
  // eslint-disable-next-line i18next/no-literal-string
  const lbUserId = uniqueIdGenerator('c-')
  const isSecure = isBrowser() ? window.location.protocol === 'https:' : true
  setCookie(ANALYTIC_COOKIES.LB_USER_ID, lbUserId, 400 * 24 * 60, isSecure, false)
  setCookie(ANALYTIC_COOKIES.LB_USER_FIRST_ACCESS, isSecure, 1)
}

// NOTE: algolia does not support colons in the user id. For backward compatibility,
// we are replacing colons with hyphen for search API calls and algolia search events.
export const getLbUserIdWithoutColons = () => {
  return getlbUserId()?.replace(/:/g, '-') ?? ''
}
